import React from "react";
import Container from "../../components/container";

const PublicLayout = ({ children }) => {
  return <Container>{children}</Container>;
};

export default PublicLayout;
